import { render, staticRenderFns } from "./AttachedNoteEdit.vue?vue&type=template&id=242a95f0"
import script from "./AttachedNoteEdit.vue?vue&type=script&lang=js"
export * from "./AttachedNoteEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports